<template>
  <div :class="payTypeShow ? 'pay in' : 'pay out'">
    <div class="pay-nav">
      <img class="pay-nav-default-back" src="../../assets/imgs/back.png" alt="" @click="onBack" />
      {{ payTitle }}
    </div>
    <div class="pay-head">
      <span class="pay-head-title">{{ paySubTitle }}</span>
      <span class="pay-head-fee">{{ i18n.coupon_pay_fee.format(amount) }}</span>
    </div>
    <!-- <div class="pay-add" v-if="isAdd">
      <div :class="item == amount ? 'pay-add-item-active' : 'pay-add-item'" v-for="(item, index) in addList" :key="index" @click="amount = item">{{ i18n.coupon_pay_fee.format(item) }}</div>
    </div> -->
    <div class="pay-body">
      <p class="pay-body-title">{{ i18n.coupon_paytype_title }}</p>
      <div class="pay-body-type">
        <label v-for="(item, index) in payList" :key="item.value">
          <div class="payitem">
            <img :src="item.imgPath" />
            <div class="payname">
              <p>{{ $t(`confirm.${item.msg}`) }}</p>
              <span v-if="item.subMsg">{{ $t(`confirm.${item.subMsg}`) }}</span>
            </div>
          </div>
          <input type="radio" :checked="item.check" :value="item.value" name="paytype" @change="changeRadio(index, item.value)" />
        </label>
      </div>
    </div>
    <div class="pay-button" @click="goPay">
      {{ i18n.coupon_pay_button }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    payTypeShow: {
      type: Boolean,
      default: false
    },
    pPrice: {
      type: Number || String,
      default: 0
    },
    payTitle: {
      type: String,
      default: ''
    },
    paySubTitle: {
      type: String,
      default: ''
    },
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['lang', 'browser']),
    i18n () {
      return this.$t('coupon')
    },
    i18nMsg () {
      return this.$t('msg')
    }
  },
  data () {
    return {
      payTypeValue: 'AlipayCN',
      payList: [{
        imgPath: require('../../assets/imgs/alipay.png'),
        msg: '支付宝',
        check: true,
        value: 'AlipayCN'
      },
      {
        imgPath: require('../../assets/imgs/alipayHK.png'),
        msg: '支付宝HK',
        check: false,
        value: 'AlipayHK'
      },
      {
        imgPath: require('../../assets/imgs/unionpay.png'),
        msg: '银联',
        check: false,
        value: 'UnionPay'
      },
      {
        imgPath: require('../../assets/imgs/wxpay.png'),
        msg: '微信',
        check: false,
        value: 'WeChat'
      },
      {
        imgPath: require('../../assets/imgs/icon_paypal.png'),
        msg: 'PayPal',
        subMsg: 'paypalsubmsg',
        check: false,
        value: 'Paypal'
      }],
      amount: 0,
      addList: ['198', '300', '500']
    }
  },
  methods: {
    onBack () {
      this.$emit('back', false)
    },
    changeRadio (index, value) {
      this.payList.map(item => {
        item.check = false
      })
      this.payList[index].check = true
      this.payTypeValue = value
      this.$emit('changeRadio', { index: index, value: value })
    },
    goPay () {
      this.$emit('goPay', this.payTypeValue, this.amount)
    }
  },
  mounted () {
    this.amount = this.pPrice
  }
}
</script>

<style lang="less" scoped>
  @keyframes in {
  0%{
    transform: translateY(100%);
    opacity: 0;
  }
  100%{
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes out {
  0%{
    transform: translateY(0);
    opacity: 1;
  }
  100%{
    transform: translateY(100%);
    opacity: 0;
  }
}
.in{
  animation: in 0.3s ease-in;
}
.out{
  animation: out 0.3s ease-out;
}
.pay{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  background: #fff;
  &-nav{
    height: 88px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #05A6DD;
    font-size: 36px;
    color: #FFFFFF;
    img{
      height: 40px;
      width: 40px;
      position: absolute;
      left: 32px;
    }
  }
  &-head{
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 40px 40px 10px;
    &-fee{
      color: #05A6DD;
      font-size: 48px;
      margin: 10px 0;
    }
  }
  &-add{
    display: flex;
    justify-content: space-between;
    padding: 10px 40px;
    &-item{
      padding: 10px 40px;
      border-radius: 8px;
      border: 1px solid #05A6DD;
    }
    &-item-active{
      padding: 10px 40px;
      border-radius: 8px;
      border: 1px solid #05A6DD;
      background: #05A6DD;
    }
  }
  &-body{
    margin: 0 40px;
    p{
      line-height: 1.5;
      // border-bottom: solid 2px #05A6DD;
    }
    &-type{
      label{
        display: flex;
        height: 80px;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        .payitem{
          display: flex;
          justify-content: center;
          align-items: center;
          .payname{
            margin-left: 20px;
            p{
              margin: 0;
            }
            span{
              display: block;
              font-size: 20px;
            }
          }
          img{
            width: 50px;
            height: 50px;
          }
        }
      }
    }
  }
  &-button{
    position: fixed;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    width: 70%;
    height: 80px;
    background: #05A6DD;
    border-radius: 40px;
    color: #fff;
    text-align: center;
    line-height: 80px;
  }
}
</style>
